import Constants from '../../globals/Constants';
import {fabric} from 'fabric-webpack';

const minSize = 25;

const initializeEventListeners = (canvas: any): void => {
   const scaling = (event: any): void => {
      if (event.target.shapeType !== Constants.annotation.type.rect) {
         return;
      }

      const square = event.target;

      if (square.originX === 'left' && (square.__corner === 'tl' || square.__corner === 'ml' || square.__corner === 'bl')) {
         square.originX = 'right';
         square.left = square.originalState.left + square.originalState.width + square.strokeWidth;
      }

      if (square.originY === 'top' && (square.__corner === 'mt' || square.__corner === 'tl' || square.__corner === 'tr')) {
         square.originY = 'bottom';
         square.top = square.originalState.top + square.originalState.height + square.strokeWidth;
      }

      square.width = Math.max(square.width * square.scaleX, minSize);
      square.height = Math.max(square.height * square.scaleY, minSize);
      square.scaleX = 1;
      square.scaleY = 1;
      canvas.setActiveObject(square);
   };

   const modified = (event: any): void => {
      if (event.target.shapeType !== Constants.annotation.type.rect) {
         return;
      }

      const square = event.target;

      square.width = square.width * square.scaleX;
      square.height = square.height * square.scaleY;
      square.scaleX = 1;
      square.scaleY = 1;

      if (square.originX === 'right') {
         square.left = square.left - square.width - square.strokeWidth;
         square.originX = 'left';
      }

      if (square.originY === 'bottom') {
         square.top = square.top - square.height - square.strokeWidth;
         square.originY = 'top';
      }

      canvas.setActiveObject(square);
   };

   canvas.on('object:scaling', scaling);
   canvas.on('object:modified', modified);
};

const turnOnMouseEventListeners = (canvas: any, color: any): void => {
   let started = false;
   let x = 0;
   let y = 0;
   turnOffMouseEventListeners(canvas);

   const mouseDown = (event: any): void => {
      if (canvas.getActiveObject() && canvas.getActiveObject().width > 10) {
         return;
      }

      const mouse = canvas.getPointer(event.e);
      started = true;
      x = mouse.x;
      y = mouse.y;
      canvas.on('mouse:up', mouseUp);

      const square = new fabric.Rect({
         width: 0,
         height: 0,
         left: x,
         top: y,
         stroke: color,
         visible: false,
         fill: Constants.annotation.transparentColor,
         strokeWidth: Constants.annotation.strokeWidth * canvas.strokeScale,
         lockScalingFlip: true,
         originX: 'left',
         originY: 'top',
         hasRotatingPoint: false,
         padding: Constants.annotation.controlsPadding,
         shapeType: Constants.annotation.type.rect,
         perPixelTargetFind: true,
         targetFindTolerance: 10
      });

      canvas.add(square);
      canvas.setActiveObject(square);
   };

   const mouseMove = (event: any): void => {
      if (!started) {
         return;
      }

      const mouse = canvas.getPointer(event.e);
      const square = canvas.getActiveObject();

      if (!(mouse.x - x) || !(mouse.y - y)) {
         return;
      }

      if (x > mouse.x) {
         square.set({left: mouse.x});
      }

      if (y > mouse.y) {
         square.set({top: mouse.y});
      }

      square.set({width: Math.abs(x - mouse.x)});
      square.set({height: Math.abs(y - mouse.y)});
      square.set('visible', true);
      square && square.setCoords();
      canvas.selection = false;
      canvas.setActiveObject(square);
      canvas.renderAll();
   };

   const mouseUp = (): void => {
      const square = canvas.getActiveObject();

      if (square && square === 0 && square.height === 0) {
         canvas.remove(square);
      }

      started = false;
      canvas.selection = true;
      canvas.trigger('object:added');
      canvas.deactivateAll();
      canvas.renderAll();
      canvas.off('mouse:up');
   };

   canvas.defaultCursor = 'crosshair';
   canvas.on('mouse:down', mouseDown);
   canvas.on('mouse:move', mouseMove);
   canvas.on('mouse:up', mouseUp);
};

const turnOffMouseEventListeners = (canvas: any): void => {
   canvas.defaultCursor = 'default';
   canvas.off('mouse:down');
   canvas.off('mouse:move');
   canvas.off('mouse:up');
};

export default {
   turnOnMouseEventListeners,
   turnOffMouseEventListeners,
   initializeEventListeners
};